export const REQUEST_PARTNER_LIST_WITH_DETAILS = "REQUEST_PARTNER_LIST_WITH_DETAILS"